export const getNestedErrorMessage = (data: Record<string, unknown>) => {
  if (typeof data !== 'object' && !Array.isArray(data)) {
    return ''
  }

  return (
    Object.values(data).flatMap((prop) =>
      Array.isArray(prop) && prop.length > 0 ? prop.map((item) => item.error_message) : []
    )[0] ?? ''
  )
}
